import styled from "styled-components";

export const StateWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 36px 20px;
	min-height: 160px;
	text-align: center;
	border-radius: 14px;
	background: var(--input-bg-has-value);
`;

export const StateTitle = styled.div`
	color: var(--content-text-color);
	font-size: 15px;
	font-weight: 600;
`;

export const StateDescription = styled.div`
	color: var(--secondary-text-color);
	font-size: 13px;
	max-width: 320px;
	line-height: 1.5;
`;

export const RetryButton = styled.button`
	border: none;
	border-radius: 50px;
	padding: 10px 22px;
	background: var(--content-text-color);
	color: var(--profile-page-wrapper-bg);
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.9;
	}
`;
